module.exports = __webpack_public_path__ + "img/f0a312e.png";